
import VolumeLow from "../../../assets/outline/VolumeLow.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VolumeLowIcon({ className, dataTestid = "VolumeLowIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VolumeLow data-testid={dataTestid} className={classes} {...rest} />
  );
}
